module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_c('span', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-A"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/cover"
    }
  }, [_vm._v("Legacy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/section3"
    }
  }, [_vm._v("Prologue - Journey Year 753")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/section4"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/section5"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/section6"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/section7"
    }
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/section8"
    }
  }, [_vm._v("Chapter 5")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 31")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 32")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 33")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 34")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-A"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prolog - Four Beginnings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter One - April 2005")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twelve")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirteen ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fourteen ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifteen ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixteen ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seventeen ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eighteen ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nineteen ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-One ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Two ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Three ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Four")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Five ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Six")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Seven ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Eight ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Nine ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-One ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Two ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Three ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Four")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Five")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Six ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Seven ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Nine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty-One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty-Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty-Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty-Four")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty-Five")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty-Six")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty-Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty-Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty-Nine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifty-One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifty-Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifty-Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifty-Four")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifty-Five ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter  Fifty-Six")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifty-Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifty-Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifty-Nine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixty ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixty-One ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixty-Two ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixty-Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixty-Four")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixty-Five")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilog - Four Beginnings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-A"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_cov",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eternity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch01#ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Recovered Earth, Independent Territory of New Zealand, A. D. 2046")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Terrestrial Hexamon, Earth Orbit, Axis Euclid")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Gala, Island of Rhodos, Greater Alexandreian Oikoumen?, Year of Alexandros 2331-2342")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Terrestrial Hexamon, Axis Euclid")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Earth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Thistledown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Gaia, Near Alexandreia, Year of Alexandros 2345")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Earth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Thistledown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Gaia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 Earth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 Gaia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 Thistledown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 Gaia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 Thistledown City")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 Gaia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 Thistledown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 Gaia, Alexandreia, Lokhias Promontory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19 Thistledown, Fifth Chamber")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 Gaia, Alexandreia, Lokhias Promontory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21 Thistledown, Fifth Chamber")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22 Gaia, Alexandreia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23 Thistledown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24 Gaia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch25#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25 Thistledown City")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch26#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26 Gaia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch27#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27 Thistledown, Fourth Chamber")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch28#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28 Earth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch29#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29 Thistledown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch30#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30 Gaia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch31#ch31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31 Gaia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch32#ch32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32 Thistledown City")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch33#ch33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33 Thistledown City")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch34#ch34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34 Thistledown City Memory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch35#ch35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35 Rhita")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch36#ch36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36 Thistledown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch37#ch37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37 The Way")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch38#ch38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38 Thistledown City")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch39#ch39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39 The Way")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch40#ch40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40 The Hawaiian Islands")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch41#ch41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41 Thistledown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch42#ch42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42 Hawaii")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch43#ch43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43 The Way, Efficient Gaia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch44#ch44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44 Thistledown City")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch45#ch45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45 Thistledown, the Orbiting Precincts, and Earth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch46#ch46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46 Thistledown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch47#ch47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47 Earth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch48#ch48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48 Thistledown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch49#ch49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49 Earth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch50#ch50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50 Thistledown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch51#ch51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51 Thistledown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch52#ch52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52 Efficient Gaia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch53#ch53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53 Earth, Thistledown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch54#ch54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54 Earth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch55#ch55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55 Thistledown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch56#ch56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56 Earth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch57#ch57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57 Halfway")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch58#ch58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58 Thistledown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch59#ch59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59 Thistledown City")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch60#ch60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60 Earth, Christchurch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch61#ch61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61 Thistledown City")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch62#ch62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62 Thistledown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch63#ch63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63 Earth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch64#ch64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64 The Way")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch65#ch65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65 Thistledown City")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch66#ch66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66 The Seventh Chamber")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch67#ch67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67 The Way")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch68#ch68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68 Between")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch69#ch69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69 The Beginning of the Way")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch70#ch70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70 The Way")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch71#ch71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71 Thistledown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch72#ch72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72 The Beginning of the Way")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch73#ch73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73 Thistledown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch74#ch74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74 The Way")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch75#ch75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75 Axis Euclid")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch76#ch76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76 Earth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch77#ch77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77 Thistledown City")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch78#ch78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78 The Way")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch79#ch79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79 Axis Euclid")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch80#ch80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80 The Way")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch81#ch81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81 Home")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch82#ch82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82 In the Flaw")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ch83#ch83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83 Timbl")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_bm01#bm01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EPILOGUE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9780759283961_ack01#ack01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4529687c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bundle_content.vue
// module id = 69
// module chunks = 0